import { useLang } from '@/i18n';
import EfProductCompareC from '@elem/ui/ef-product-compare-c';
import EfTitle from '@elem/ui/ef-title';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');
    const { locale = 'us' } = useRouter();

    const imgAllA = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724578776333/dd2.png',
            h5: '',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725015884744/r3_plus_eu.png',
            h5: '',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725015958676/r3_plus_uk.png',
            h5: '',
        },
        PH: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751251572267/1.png',
            h5: '',
        },
    };
    const imgLocaleA: any = {
        us: imgAllA.NA,
        ca: imgAllA.NA,
        br: imgAllA.NA,
        mx: imgAllA.NA,
        uk: imgAllA.UK,
        eu: imgAllA.EU,
        de: imgAllA.EU,
        fr: imgAllA.EU,
        it: imgAllA.EU,
        es: imgAllA.EU,
        nl: imgAllA.EU,
        ph: imgAllA.PH,
    };
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];

    const imgAllB = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724578776517/dd3.png',
            h5: '',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725015852850/r3_eu.png',
            h5: '',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725015937853/r3_uk.png',
            h5: '',
        },
        PH: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751251572660/2.png',
            h5: '',
        },
    };
    const imgLocaleB: any = {
        us: imgAllB.NA,
        ca: imgAllB.NA,
        br: imgAllB.NA,
        mx: imgAllB.NA,
        uk: imgAllB.UK,
        eu: imgAllB.EU,
        de: imgAllB.EU,
        fr: imgAllB.EU,
        it: imgAllB.EU,
        nl: imgAllB.EU,
        es: imgAllB.EU,
        ph: imgAllB.PH,
    };
    const imgB = imgLocaleB[locale] || imgLocaleB['eu'];

    const imgAllC = {
        PH: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751251572454/3.png',
            h5: '',
        },
    };
    const imgLocleC: any = {
        ph: imgAllC.PH,
    };
    const imgC = imgLocleC[locale] || imgAllC.PH;

    const listA = {
        pc:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1751251650855/Frame%201612706902.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1724578776173/dd1.png',
        title: t('win3_a_title'),
        desc: t('win3_a_desc'),
        specList: [
            locale === 'ph' && {
                title: t('win3_a_item0_t'),
                desc: t('win3_a_item0_b'),
            },
            {
                title: t('win3_a_item1_t'),
                desc: t('win3_a_item1_b'),
            },
            {
                title: t('win3_a_item2_t'),
                desc: t('win3_a_item2_b'),
            },
            {
                title: t('win3_a_item3_t'),
                desc: t('win3_a_item3_b'),
            },
            {
                title: t('win3_a_item4_t'),
                desc: t('win3_a_item4_b'),
            },
            {
                title: t('win3_a_item5_t'),
                desc: t('win3_a_item5_b'),
            },
            {
                title: t('win3_a_item6_t'),
                desc: t('win3_a_item6_b'),
            },
            {
                title: t('win3_a_item7_t'),
                desc: t('win3_a_item7_b'),
            },
            {
                title: t('win3_a_item8_t'),
                desc: t('win3_a_item8_b'),
            },
            {
                title: t('win3_a_item9_t'),
                desc: t('win3_a_item9_b'),
            },
        ],
    };

    const listB = {
        pc: imgA.pc,
        h5: '',
        title: t('win3_b_title'),
        desc: t('win3_b_desc'),
        specList: [
            locale === 'ph' && {
                title: t('win3_b_item0_t'),
                desc: t('win3_b_item0_b'),
            },
            {
                title: t('win3_b_item1_t'),
                desc: t('win3_b_item1_b'),
            },
            {
                title: t('win3_b_item2_t'),
                desc: t('win3_b_item2_b'),
            },
            {
                title: t('win3_b_item3_t'),
                desc: t('win3_b_item3_b'),
            },
            {
                title: t('win3_b_item4_t'),
                desc: t('win3_b_item4_b'),
            },
            {
                title: t('win3_b_item5_t'),
                desc: t('win3_b_item5_b'),
            },
            {
                title: t('win3_b_item6_t'),
                desc: t('win3_b_item6_b'),
            },
            {
                title: t('win3_b_item7_t'),
                desc: t('win3_b_item7_b'),
            },
            {
                title: t('win3_b_item8_t'),
                desc: t('win3_b_item8_b'),
            },
            {
                title: t('win3_b_item9_t'),
                desc: t('win3_b_item9_b'),
            },
        ],
    };

    const listC = {
        pc: imgB.pc,
        h5: '',
        title: t('win3_c_title'),
        desc: t('win3_c_desc'),
        specList: [
            locale === 'ph' && {
                title: t('win3_c_item0_t'),
                desc: t('win3_c_item0_b'),
            },
            {
                title: t('win3_c_item1_t'),
                desc: t('win3_c_item1_b'),
            },
            {
                title: t('win3_c_item2_t'),
                desc: t('win3_c_item2_b'),
            },
            {
                title: t('win3_c_item3_t'),
                desc: t('win3_c_item3_b'),
            },
            {
                title: t('win3_c_item4_t'),
                desc: t('win3_c_item4_b'),
            },
            {
                title: t('win3_c_item5_t'),
                desc: t('win3_c_item5_b'),
            },
            {
                title: t('win3_c_item6_t'),
                desc: t('win3_c_item6_b'),
            },
            {
                title: t('win3_c_item7_t'),
                desc: t('win3_c_item7_b'),
            },
            {
                title: t('win3_c_item8_t'),
                desc: t('win3_c_item8_b'),
            },
            {
                title: t('win3_c_item9_t'),
                desc: t('win3_c_item9_b'),
            },
        ],
    };

    const listD = {
        pc: imgC.pc,
        h5: '',
        title: t('win3_d_title'),
        desc: t('win3_d_desc'),
        specList: [
            {
                title: t('win3_d_item0_t'),
                desc: t('win3_d_item0_b'),
            },
            {
                title: t('win3_d_item1_t'),
                desc: t('win3_d_item1_b'),
            },
            {
                title: t('win3_d_item2_t'),
                desc: t('win3_d_item2_b'),
            },
            {
                title: t('win3_d_item3_t'),
                desc: t('win3_d_item3_b'),
            },
            {
                title: t('win3_d_item4_t'),
                desc: t('win3_d_item4_b'),
            },
            {
                title: t('win3_d_item5_t'),
                desc: t('win3_d_item5_b'),
            },
            {
                title: t('win3_d_item6_t'),
                desc: t('win3_d_item6_b'),
            },
            {
                title: t('win3_d_item7_t'),
                desc: t('win3_d_item7_b'),
            },
            {
                title: t('win3_d_item8_t'),
                desc: t('win3_d_item8_b'),
            },
            {
                title: t('win3_d_item9_t'),
                desc: t('win3_d_item9_b'),
            },
        ],
    };

    const listAll = [listA, listB, listC];
    const PH_ListAll = [listA, listB, listC, listD];
    return (
        <div className={styles.compare}>
            <EfTitle hasAnimation={false}>{t('win3_title')}</EfTitle>
            <EfProductCompareC items={locale === 'ph' ? PH_ListAll : listAll} theme="bg1" />
        </div>
    );
}
